<template>
<span v-if="canSplitDetail()">
  <el-tooltip
    class="item el-icon-edit-tooltip"
    effect="dark"
    :enterable="false"
    :content="$t('customerService.shipment.splitShipmentDetail')"
    placement="top-start"
  >
    <i class="el-icon-copy-document icon-action" @click="dialogVisible = true"></i>
  </el-tooltip>
  <el-dialog
    v-on:open="resetForm"
    :title="$t('customerService.shipment.splitShipmentDetail')"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="25%"
    append-to-body
    class="dialog-with-cols"
  >
    <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :span="24" class="form-vertical-item">
          <label class="span-small-list"><span style="color: red">*</span>{{ $t('customerService.shipment.splitShipmentDetailMessage') }}</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="form-vertical-item">
          <el-form-item
            label-position="right"
            class="inline-input"
            prop="numberUnits"
          >
            <el-input-number
              v-model="form.numberUnits"
              v-numeric-validation
              :controls="false"
              :precision="0"
              :min="0"
              :max="999"
              @focus="$event.target.select()"
              class="width-100p"
              id="form-number-units"
              ref="unit"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button
        type="primary"
        id="form-save-button"
        @click="submitForm"
        size="mini"
      >
        {{ $t('customerService.shipment.splitShipmentDetail') }}
      </el-button>
      <el-button
        id="form-refresh-button"
        @click="resetForm"
        size="mini"
      >
        {{ $t('common.clear') }}
      </el-button>
    </div>
  </el-dialog>
</span>
</template>

<script>
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';

export default {
  props: {
    shipmentId: {
      type: Number,
      default: null
    },
    shipmentStatus: {
      type: Number,
      default: null
    },
    shipmentDetail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters([
      'shipment'
    ]),
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        numberUnits: null,
      },
      formRules: {
        numberUnits: [
          {
            required: true,
            message: this.$t(
              'customerService.shipment.error.numberUnitsRequired'
            ),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    resetForm() {
      this.form.numberUnits = this.shipmentDetail.numberUnits;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    canSplitDetail() {
      const hasShipmentClosedOrCancelled = this.shipmentStatus === constants.SHIPMENT.STATUS[5].value
        || this.shipmentStatus === constants.SHIPMENT.STATUS[6].value;
      return (
        this.$can(this.permissions.BILLING.EDIT_SHIPMENT)
        && !this.shipment.isEditingDetails
        && !hasShipmentClosedOrCancelled
        && this.shipmentDetail.numberUnits > 1
      );
    },
    submitForm() {
      if (this.form.numberUnits < 1 || this.form.numberUnits >= this.shipmentDetail.numberUnits) {
        this.$message.error(this.$t('customerService.shipment.error.numberUnitsInvalid'));
        return;
      }

      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      this.$store
        .dispatch('shipment/splitDetail', {
          shipmentId: this.shipmentId,
          shipmentDetailId: this.shipmentDetail.id,
          numberOfUnitToPutout: this.form.numberUnits
        })
        .then((response) => {
          this.$message.success(response.message);
          this.$emit('detailSplit');
          this.dialogVisible = false;
        })
        .finally(() => {
          loading.close();
        });
    },
  }
};
</script>
